<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Customer Challenge</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <p>
      Customer: <b>{{ customerChallenge.customer_first_name }} {{ customerChallenge.customer_last_name }}</b>
      <br>
      Challenge: <b>{{ customerChallenge.challenge_name }}</b>
    </p>
    <p>
      Status:
      <b>
        <span *ngIf="customerChallenge.is_complete" class="text-success">
          Complete ({{ customerChallenge.count }}/{{ customerChallenge.challenge_goal }} check-ins)
          <ng-container *ngIf="customerChallenge.challenge_will_prompt_for_prize">
            - {{ customerChallenge.prize_given ? 'Prize Received' : 'Awaiting Prize' }}
          </ng-container>
        </span>
        <ng-container *ngIf="!customerChallenge.is_complete">
          <span *ngIf="customerChallenge.challenge_has_ended" class="text-danger">
            Incomplete ({{ customerChallenge.count }}/{{ customerChallenge.challenge_goal }} check-ins)
          </span>
          <span *ngIf="!customerChallenge.challenge_has_ended">
            {{ customerChallenge.count }}/{{ customerChallenge.challenge_goal }} check-ins
          </span>
        </ng-container>
      </b>
    </p>
    <p *ngIf="!inEditMode">
      Challenge Start:
      <b *ngIf="customerChallenge.challenge_start">{{ dateStringFromISO8601(customerChallenge.challenge_start) }}</b>
      <span *ngIf="!customerChallenge.challenge_start" class="text-muted">None</span>
      <br>
      Challenge End:
      <b *ngIf="customerChallenge.challenge_end">{{ dateStringFromISO8601(customerChallenge.challenge_end) }}</b>
      <span *ngIf="!customerChallenge.challenge_end" class="text-muted">None</span>
      <br>
      <a href="#" (click)="inEditMode = true;$event.preventDefault();">Edit Start/End</a>
    </p>
    <div class="form-group row" *ngIf="inEditMode">
      <div class="col-6">
        <label for="challengeStartInput">Challenge Start</label>
        <app-date-picker [id]="'challengeStartInput'"
                         [(content)]="customerChallenge.challenge_start"></app-date-picker>
        <div class="form-text text-danger">{{ errors.challenge_start }}</div>
      </div>
      <div class="col-6">
        <label for="challengeEndInput">Challenge End</label>
        <app-date-picker [id]="'challengeEndInput'"
                         [(content)]="customerChallenge.challenge_end"></app-date-picker>
        <div class="form-text text-danger">{{ errors.challenge_end }}</div>
      </div>
    </div>
    <div class="form-group" *ngIf="customerChallenge.challenge_reward_instructions">
      <label>Reward Instructions</label>
      <p class="mb-0" style="white-space: pre-wrap">{{ customerChallenge.challenge_reward_instructions }}</p>
    </div>
    <div class="form-group" *ngIf="customerChallenge.is_complete">
      <label for="prizeGivenSelect">Prize given</label>
      <select class="custom-select"
              [(ngModel)]="customerChallenge.prize_given"
              id="prizeGivenSelect" name="prize_given">
        <option [ngValue]="false">No</option>
        <option [ngValue]="true">Yes</option>
      </select>
      <div class="form-text text-danger">{{ errors.prize_given }}</div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-danger"
            (click)="handleRemove()"
            [disabled]="loadingSubmit"
            [class.disabled]="loadingSubmit">
      {{ loadingSubmit ? 'Loading...' : 'Remove' }}
    </button>
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()"
            [disabled]="loadingSubmit"
            [class.disabled]="loadingSubmit">
      Cancel
    </button>
    <button type="button" class="btn btn-primary"
            (click)="handleSaveEdit()"
            [disabled]="loadingSubmit"
            [class.disabled]="loadingSubmit">
      {{ loadingSubmit ? 'Loading...' : 'Save' }}
    </button>
  </div>

</ng-container>
